/** @jsx jsx */
import { jsx } from 'theme-ui'
import { useState, useRef } from 'react'
import { number, oneOf, string } from 'prop-types'
import useInterval from '../../utils/useInterval'

const RedirectCounter = ({
  countDownFrom,
  countDownUnit = 'second',
  redirectUrl,
  ...props
}) => {
  if (countDownUnit === 'minute') {
    countDownFrom = countDownFrom * 60
  }

  const startTime = useRef(Date.now())
  const countDownTime = useRef(countDownFrom)
  const [counter, setCounter] = useState(countDownFrom)
  const redirectToLogIn = () => (window.location.href = redirectUrl)

  useInterval(() => {
    redirectToLogIn()
  }, countDownFrom * 1000)

  useInterval(() => {
    const elapsedMilliSecs = Date.now() - startTime.current
    const elapsedSecs = Math.floor(elapsedMilliSecs / 1000)

    setCounter(countDownTime.current - elapsedSecs)
  }, 1000)

  return (
    <span {...props}>
      {countDownUnit === 'second' && (
        <span sx={{ fontWeight: 'bold' }}>{counter} seconds</span>
      )}
      {countDownUnit === 'minute' && (
        <span>
          {Math.floor(counter / 60)} : {('0' + (counter % 60)).slice(-2)}
        </span>
      )}
    </span>
  )
}

RedirectCounter.propTypes = {
  countDownFrom: number.isRequired,
  redirectUrl: string.isRequired,
  countDownUnit: oneOf(['second', 'minute']),
}

export default RedirectCounter
